export default __webpack_public_path__ + "static/media/maps.af32d2bb.png";